import styles from './legacy-clp-layout-container.module.scss'

import type { ReactNode } from 'react'

export interface CLPLayoutContainerLegacyProps {
  /**
   * When the first widget on the page is a banner, suppress the top margin so
   * the banner's own top spacing isn't doubled.
   */
  isBannerFirst: boolean
  children: ReactNode
}

/**
 * Legacy CLP layout container — owns the SCSS module with the 2.4rem top
 * margin. Imported only via the `CLPLayoutContainer` switcher when
 * `shouldUseDesignSystem()` is false, so the SCSS doesn't get bundled into
 * the DS code path.
 */
export function CLPLayoutContainerLegacy({ isBannerFirst, children }: CLPLayoutContainerLegacyProps) {
  return <div className={isBannerFirst ? undefined : styles.container}>{children}</div>
}
